<header>
  <div class="header-content">
    <img src="assets/images/soldo-full-colour-logo.webp" alt="Soldo logo">

    <form *ngIf="languageSelectorEnabled" [formGroup]="form">
      <ng-select
        data-cy="Header_LanguageSelector_LanguageMenu"
        [items]="availableLanguages" dropdownPosition="bottom"
        [clearable]="false" [searchable]="false"
        formControlName="language">
        <ng-template ng-option-tmp ng-label-tmp let-item="item">
          <div class="flag-icon" style="background-image: url(/assets/round-flag-icons/{{item.flag}}.svg)"></div>
          <span [attr.translate]="'no'">{{ item.label }}</span>
        </ng-template>
      </ng-select>
    </form>
  </div>
</header>
